__turbopack_context__.v({
  "container": "CommentFieldMatch-module__S8xWXG__container",
  "inline": "CommentFieldMatch-module__S8xWXG__inline",
  "owner": "CommentFieldMatch-module__S8xWXG__owner",
  "ownerName": "CommentFieldMatch-module__S8xWXG__ownerName",
  "quote": "CommentFieldMatch-module__S8xWXG__quote",
  "quoteText": "CommentFieldMatch-module__S8xWXG__quoteText",
});
